(function () {
	angular
		.module('trackeye')
		.factory('AuthenticateLogger', _AuthenticateLoggerFactory);

	_AuthenticateLoggerFactory.$inject = [];

	function _AuthenticateLoggerFactory() {

		/**
		 *
		 * @param {ResponseXHR} xhr
		 * @constructor
		 */
		function Authenticate(xhr) {
			this.debug = false;
			this.silent = false;
			this.level = 'info'; //debug|info|err
			this.xhr = xhr;

			this.message = undefined;
			this.message_id = undefined;

			var username = xhr.getRequestData().username;

			if (this.xhr.Unautorized()) {
				this.message_id = "AUTHENTICATE_CLIENT_ERROR_CREDENTIALS";
				this.message = "authenticate: Incorrect credentials";
			} else if (this.xhr.is40x()) {
				this.message_id = "AUTHENTICATE_CLIENT_ERROR";
				this.message = "authenticate: "+ this.xhr.getStatus()+" - Bad request";
			} else if (this.xhr.is50x()) {
				this.level = "err";
				this.message_id = "AUTHENTICATE_SERVER_ERROR";
				this.message = "authenticate: "+ this.xhr.getStatus() + " - Server authentication error"
			}
		}

		Authenticate.prototype.isSilent = function () {
			return this.silent;
		};

		Authenticate.prototype.getLevel = function () {
			return this.level;
		};

		Authenticate.prototype.getMessageId = function () {
			return this.message_id;
		};

		Authenticate.prototype.getMessage = function () {
			return this.message;
		};

		Authenticate.prototype.getData = function () {
			return undefined;
		};

		Authenticate.prototype.getXhr = function () {
			return this.xhr;
		};

		Authenticate.prototype.getNoticeType = function () {
			// success|info|warning|danger
			return this.xhr.is50x() ? "danger" : "warning";
		};

		Authenticate.prototype.getNoticeMessage = function () {
			return "STR_NOTICE_" + this.message_id;
		};

		Authenticate.prototype.getTranslateValues = function () {
			return {};
		};

		return Authenticate;
	}
})();